var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 ml-auto mr-auto"},[_c('div',{staticClass:"card card-calendar"},[_c('div',{staticClass:"card-body"},[_c('div',{attrs:{"id":"fullCalendar"}})])])])])])
}]

export { render, staticRenderFns }